export default __webpack_public_path__ + "static/media/blemishes_prop.6da38c6d.svg";